<template>
	<div class="stats">
		<div class="col-md-12 content">

      <h4>Listado Bibliotecas</h4>

      <form v-on:submit.prevent>
        <div class="form-head fix">
          <div class="input-group widthPer30">
            <div class="input-group-addon"><i class="fa fa-filter"></i></div>
            <input type="text" class="form-control" placeholder="Nombre de la bilbioteca" maxlength="150" v-model="filterValue">
          </div>     
        </div>
      </form>

      <br>

      <div class="blog-post pall20">
        <div class="row">
          <div class="col-md-12">
            <div class="over-scroll h300">

              <div v-if="loading">
                <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
              </div>

              <table v-else class="table table-hover v-align-middle fixed-header" style="width:100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th class="right">Acciones</th>
                    <th class="right">Logins</th>
                    <th class="right">Búsquedas</th>
                    <th class="right">Fichas Extendidas</th>
                    <th class="right">Selecciones</th>
                    <th class="center">Ver Logs</th>
                  </tr>
                </thead> 
                <tbody style="background-color: #F2F2F2;">
                  <tr v-for=" (row, i) in bibliotecasFiltered " :key="i">
                    <th class="center">{{ i + 1 }}</th>
                    <td>{{ row.USUARIO }}</td>
                    <td class="right" title="Acciones">{{ row.ACCIONES }}</td>
                    <td class="right" title="Logins">{{ row.LOGINS }}</td>
                    <td class="right" title="Búsquedas">{{ row.BUSQUEDAS }}</td>
                    <td class="right" title="Fichas Extendidas">{{ row.FICHAS_EXTENDIDAS }}</td>
                    <td class="right" title="Selecciones">{{ row.SELECCIONES }}</td>
                    <td class="center">
                      <a @click.prevent="loadCalendarData(row.ID_USUARIO, row.USUARIO)" href=""><i class="fa fa-calendar"></i></a>
                    </td>
                  </tr>                
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="calendar" class="blog-post pall20 mt50">

        <div v-if="loadingCalendar">
          <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
        </div>

        <div v-else class="row">
          <div class="col-md-12">
            <h4>{{ activeBiblName }}</h4>
            <div v-if="loadingChart">Cargando gráfico...</div>
            <vue-chart
              v-show=" chartCols.length > 0 "
              chart-type="Calendar"
              :packages="['calendar']"
              :columns="chartCols"
              :rows="chartData"
              :options="chartOptions"
              :chart-events="chartEvents"
              style="height: 250px;"
              class="mt50"
              ref="thisherechart">
            </vue-chart>
          </div>          
        </div>    
      </div>     

      <div v-if=" actions " class="blog-post pall20 mt50">
        <div class="row">
          <div v-if="loadingActions">
            <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
          </div>
          <div v-else class="col-md-12">
            <h4>{{ activeBibleDate }}</h4>
            <table class="log-table">
              <thead>
                <tr>
                  <th>Origen</th>
                  <th>Tiempo</th>
                  <th width="1%"></th>
                  <th>ACCIÓN</th>
                  <th>DETALLES</th>
                  <th width="20%">Error</th>
                </tr>
              </thead>
              <tbody>
                <template v-for=" (action, index) in activeBiblActions ">
                  <tr v-if=" index > 0 " :key="index">
                    <td></td>
                    <td><span class="log-duration">{{ action.DURACION }}</span></td>
                    <td><span class="log-v-line"></span></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="right"><span class="log-ref">{{ action.REFERENCIA }}</span></td>
                    <td><span class="log-start-time">{{ action.HORA }}</span></td>
                    <td><div :class=" 'log-box bg-' + getTipo(action.TIPO) "><i :class="getIcon(action.RECURSO)"></i></div></td>
                    <td><span class="log-recurso">{{ action.DESCRIPCION }}</span></td>
                    <td>
                      <template v-if=" action.SUBTITULO.length > 0 ">
                        <span class="log-subtitle">{{ action.SUBTITULO }}</span>
                        <br>
                      </template>
                      <span class="log-action">{{ action.TITULO }}</span>
                    </td>
                    
                    <td><span class="log-error">{{ action.ERROR }}</span></td>
                  </tr>
                </template>
              </tbody>
            </table>

          </div>
        </div>
      </div>

		</div>
	</div>
</template>

<script>
	import AdminChart from './AdminChart.vue';

	import axios from 'axios';  
	import { mapGetters } from 'vuex';

	export default {
		components: { AdminChart },
    props: [ 'tmp'],
    data: function () {
      var self = this;
      return {
        loading: false,
        loadingCalendar: false,
        loadingChart: false,
        loadingActions: false,
        filterValue: '',
        calendar: 0,
        actions: 0,
        activeBiblName: '',
        activeBiblId: '',
        activeBiblActions: {},
        activeBiblDate: '',
        bibliotecas:[], 
        firstCalenderLoadBug: 0,

        chartEvents:{
          'select': function() {
            var selectedItem = self.$refs.thisherechart.chart.getSelection()[0];
            //console.log(selectedItem)
            if( typeof selectedItem !== 'undefined' ){
              if( selectedItem.hasOwnProperty("row") ){
                var d = new Date(selectedItem.date);         
                self.loadActions(d);  
              }   
            }
          },
          'ready': function() { 
            //alert('ready')
            self.loadingChart = false;
          }        
        },      
        chartCols: [],
        /*chartData: [["2018, 2, 6",12],["2018, 2, 20",8],["2018, 2, 26",306],["2018, 2, 27",56]],*/
        /*chartData: [
          [ new Date(2012, 3, 13), 37032 ],
          [ new Date(2012, 3, 14), 38024 ],
          [ new Date(2012, 3, 15), 38024 ],
          [ new Date(2012, 3, 16), 38108 ],
          [ new Date(2012, 3, 17), 38229 ]
        ],*/
        chartData: [],
        chartOptions:{
          calendar: { 
            cellSize: 20,
          },
          tooltip: { isHtml: true },
          height: 250,
          chartArea: { 'width': '100%', 'height': '50%' },
          theme: 'material',
          fontName: 'Open Sans', 
          colorAxis: { colors: ['#FDCFD1', '#E10913']},          
        },
      
      }
    },
    mounted(){
      this.loadBibliotecas();
    },
    computed: {
      ...mapGetters(['getLocale', 'getApiUrl']),
      bibliotecasFiltered: function(){
        return this.bibliotecas.filter( (item) => {
          return item.USUARIO.toLowerCase().includes(this.filterValue.toLowerCase());
        })
      },
    },
    methods:{	   
      convertDate(date){
        //return date.getFullYear() + '-' + date.getMonth()+1 + '-' + date.getDate();
        return date.toISOString().substr(0,10);
      },
      loadBibliotecas(){
        this.showLoading('loading');
        axios.get( this.getApiUrl + this.getLocale + '/tpanel/log/usuarios' )
          .then( (respuesta) =>{ 
            this.bibliotecas = respuesta.data.data;  
            this.hideLoading('loading')
          })
        .catch( (error) =>{ 
          this.hideLoading('loading');
          alert(error.response.data.msg);
        });
      },
    	loadCalendarData(id, name){
        this.resetActions();
    		this.showLoading('loadingCalendar');

        this.chartCols = this.chartData = new Array();

        this.activeBiblId = id;

    		axios.get( this.getApiUrl + this.getLocale + '/tpanel/log/calendario/' + id)
          .then( (respuesta) =>{ 
            // Convert dates
            respuesta.data.data.chartData.forEach(
              (element) => {
                element[0] = new Date(element[0])
              }
            );

            this.chartCols = respuesta.data.data.chartCols;
            this.chartData = respuesta.data.data.chartData;

            this.loadingChart = true;

            this.activeBiblName = name;
            this.calendar = 1;

            this.hideLoading('loadingCalendar')

            /*if(this.firstCalenderLoadBug == 0){
              this.firstCalenderLoadBug = 1;
              this.loadCalendarData(id, name);
            }*/
          })
        .catch( (error) =>{ 
          this.hideLoading('loadingCalendar');
          alert(error.response.data.msg);
          //console.log(error)
        });
      },
      loadActions(date){
        this.actions = 1;
        this.showLoading('loadingActions');

        this.activeBiblActions = new Array();

        var meses = new Array ("Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre");
        var diasSemana = new Array("Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado");
        this.activeBibleDate = diasSemana[date.getDay()] + ", " + date.getDate() + " de " + meses[date.getMonth()] + " de " + date.getFullYear();
        
        date = date.toISOString().substr(0,10);

        axios.get( this.getApiUrl + this.getLocale + '/tpanel/log/acciones/' + this.activeBiblId + '/' + date)
          .then( (respuesta) =>{ 
            this.activeBiblActions = respuesta.data.data;
            this.hideLoading('loadingActions')
          })
        .catch( (error) =>{ 
          this.hideLoading('loadingActions');
          alert(error.response.data.msg);
          //console.log(error)
        });
      },
      getTipo(value){
        let tipo;
        switch(value){
          case('T'): tipo = 'todo'; break;
          case('L'): tipo = 'libros'; break;
          case('C'): tipo = 'cine'; break;
          case('M'): tipo = 'musica'; break;
          case('I'): tipo = 'infantil'; break;
          case('S'): tipo = 'series'; break;
          case('D'): tipo = 'documentales'; break;
          case('J'): tipo = 'juegos'; break;
          default: tipo = ''; break;
        }
        return tipo
      },
      getIcon(type){
        let icon;
        switch(type){
          case('ficha_extendida'): icon = 'fa fa-file-text-o'; break;
          case('busqueda'): icon = 'fa fa-search'; break;
          case('contenedor_expandido'): icon = 'fa fa-cubes'; break;
          case('seleccionar'): icon = 'fa fa-cart-plus'; break;
          case('miseleccion'): icon = 'fa fa-shopping-cart'; break;
          case('presupuesto'): icon = 'fa fa-eur'; break;
          case('misconsultas_proyecto'): icon = 'fa fa-list-ul'; break;
          case('misconsultas_referencia'): icon = 'fa fa-list-ul'; break;
          case('misconsultas_articulo'): icon = 'fa fa-list-ul'; break;
          case('misconsultas_albaran'): icon = 'fa fa-list-ul'; break;
          case('perfil'): icon = 'fa fa-cog'; break;
          case('cambiar_contrasena'): icon = 'fa fa-lock'; break;
          case('login'): icon = 'fa fa-user-circle-o'; break;
          case('logout'): icon = 'fa fa-user-circle-o'; break;
          case('registro'): icon = 'fa fa-user-circle-o'; break;
          case('restablecer_contasena'): icon = 'fa fa-cog'; break;
          default: icon = ''; break;
        }
        return icon;
      },
      resetActions(){
        this.actions = 0;
        this.activeBibleActions = '';
      },
      showLoading(type){ 
        switch(type){
          case('loading'):          this.loading = true;
          case('loadingCalendar'):  this.loadingCalendar = true;
          case('loadingActions'):   this.loadingActions = true;
        }  
      },
      hideLoading(type){ 
        switch(type){
          case('loading'):          this.loading = false;
          case('loadingCalendar'):  this.loadingCalendar = false;
          case('loadingActions'):   this.loadingActions = false;
        }  
      },
    }
	}
</script>
